import { TagChip } from "@/app/blog/components/TagChip"
import { PopulatedTag } from "@/services/tagsService"
import { ChevronRight, ExpandMore } from "@mui/icons-material"
import TreeItem from "@mui/lab/TreeItem"
import { Box, styled } from "@mui/material"

interface Props {
    tag: PopulatedTag
    selectedTagSlug: string
}

export const TagsTreeElement = ({ tag, selectedTagSlug }: Props) => {
    if (!tag) return null

    const hasChildren = tag.children.length > 0

    return (
        <StyledTreeItemRoot
            nodeId={tag.id}
            TransitionProps={{ timeout: 0 }}
            expandIcon={hasChildren ? <ChevronRight /> : null}
            collapseIcon={hasChildren ? <ExpandMore /> : null}
            label={
                <TagChip
                    variant={tag.slug === selectedTagSlug ? "filled" : "outlined"}
                    tagName={tag.name}
                    tagSlug={tag.slug}
                    sx={{ mb: 0.5 }}
                />
            }
        >
            {hasChildren && (
                <Box display="flex" flexDirection="column">
                    {tag.children.map((child) => (
                        <TagsTreeElement
                            selectedTagSlug={selectedTagSlug}
                            key={child.name}
                            tag={child}
                        />
                    ))}
                </Box>
            )}
        </StyledTreeItemRoot>
    )
}

const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
    color: theme.palette.text.secondary,
    ".MuiTreeItem-content": {
        backgroundColor: "transparent !important",
        padding: 0,
    },
}))
